import * as PopoverPrimitive from '@radix-ui/react-popover';

import { cn } from '@/lib/utils';
import './animations.css';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;

export function PopoverContent({
  className,
  align = 'center',
  sideOffset = 6,
  ...props
}: React.ComponentProps<typeof PopoverPrimitive.Content>) {
  return (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        align={align}
        sideOffset={sideOffset}
        className={cn(
          'ui-anim-pop z-50 w-72 max-h-[var(--radix-popover-content-available-height)] overflow-y-auto rounded-lg border border-border bg-popover p-3 text-popover-foreground shadow-lg',
          className,
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  );
}
